// Întrebări frecvente (/faq și /ro/faq). Răspunsurile folosesc doar informații
// deja publicate pe site; textul răspunsului apare și în datele structurate FAQPage.
// link: legătură opțională sub răspuns - path (pagină internă) sau href (extern).
const FAQ = [
  {
    id: "about",
    title: { en: "About Travel Time", ro: "Despre Travel Time" },
    items: [
      {
        q: { en: "What is Travel Time?", ro: "Ce este Travel Time?" },
        a: {
          en: "Travel Time (SC TRAVEL TIME D&R SRL) is a travel management company based in Bucharest, Romania, in business since 2005. It provides corporate travel management, corporate events management (MICE), travel program consultancy and B2B airline ticket consolidation for travel agencies through its BOOKING TIME platform.",
          ro: "Travel Time (SC TRAVEL TIME D&R SRL) este o companie de travel management din București, activă din 2005. Oferă managementul călătoriilor de afaceri, organizarea de evenimente corporate (MICE), consultanță pentru programele de travel și consolidare B2B de bilete de avion pentru agențiile de turism, prin platforma BOOKING TIME.",
        },
        link: { path: "/servicii", label: { en: "Our services", ro: "Serviciile noastre" } },
      },
      {
        q: {
          en: "Is Travel Time an accredited travel agency?",
          ro: "Travel Time este o agenție de turism acreditată?",
        },
        a: {
          en: "Yes. Travel Time is an IATA accredited agent, holds a Romanian tourism license (no. 236 / 28.04.2026) and is ISO 9001:2015 and ISO 14001:2015 certified. It is also a member of ANAT, the National Association of Romanian Travel Agencies. The certificates are linked in the footer of every page.",
          ro: "Da. Travel Time este agent acreditat IATA, are licență de turism (nr. 236 / 28.04.2026) și este certificată ISO 9001:2015 și ISO 14001:2015. Este și membră ANAT - Asociația Națională a Agențiilor de Turism din România. Certificatele pot fi consultate în subsolul fiecărei pagini.",
        },
      },
      {
        q: {
          en: "How experienced is the Travel Time team?",
          ro: "Ce experiență are echipa Travel Time?",
        },
        a: {
          en: "Travel Time has a team of over 30 professionals. Its travel consultants average 12+ years of industry experience, many of them with an extensive ticketing background, and they are fluent in English and other languages. The company works with 100+ corporate customers.",
          ro: "Travel Time are o echipă de peste 30 de profesioniști. Consultanții de travel au în medie peste 12 ani de experiență în industrie, mulți dintre ei cu o vastă experiență în ticketing, și vorbesc fluent engleza și alte limbi. Compania lucrează cu peste 100 de clienți corporate.",
        },
        link: { path: "/capabilitati", label: { en: "Capabilities", ro: "Capabilități" } },
      },
      {
        q: {
          en: "What airline recognitions has Travel Time received?",
          ro: "Ce distincții a primit Travel Time de la companiile aeriene?",
        },
        a: {
          en: "Travel Time has been recognized by airlines including Lufthansa (2025), TAROM (2024), Turkish Airlines (2023), LOT Polish Airlines (2019), Qatar Airways (2018) and Hahn Air (2017), as well as by APG.",
          ro: "Travel Time a primit distincții de la companii aeriene precum Lufthansa (2025), TAROM (2024), Turkish Airlines (2023), LOT Polish Airlines (2019), Qatar Airways (2018) și Hahn Air (2017), precum și de la APG.",
        },
      },
    ],
  },
  {
    id: "corporate",
    title: { en: "Corporate travel", ro: "Călătorii de afaceri" },
    items: [
      {
        q: {
          en: "What does corporate travel management include?",
          ro: "Ce include managementul călătoriilor de afaceri?",
        },
        a: {
          en: "Travel Time arranges flights, hotels, rail services, ground transportation, passports and visas for business travelers, with a dedicated team for each customer. Companies also get online booking tools (OBT), personalized reporting, real-time expense tracking and 24/7 emergency support.",
          ro: "Travel Time organizează zboruri, cazare, transport feroviar și terestru, pașapoarte și vize pentru angajații care călătoresc în interes de serviciu, cu o echipă dedicată fiecărui client. Companiile au acces și la instrumente de rezervare online (OBT), rapoarte personalizate, monitorizarea cheltuielilor în timp real și asistență 24/7 pentru urgențe.",
        },
        link: { path: "/servicii", label: { en: "Corporate travel management", ro: "Managementul călătoriilor de afaceri" } },
      },
      {
        q: {
          en: "How does Travel Time help companies reduce travel costs?",
          ro: "Cum ajută Travel Time companiile să reducă costurile de călătorie?",
        },
        a: {
          en: "Through consolidated volumes and access to negotiated fares, analysis of spend patterns and travel policy optimization. Travel Time also uses Amadeus robots and its proprietary Repricer Tool, which keeps searching for better fares and reissues tickets at a lower cost whenever possible.",
          ro: "Prin volume consolidate și acces la tarife negociate, prin analiza cheltuielilor și optimizarea politicii de travel. Travel Time folosește și roboți Amadeus și propriul Repricer Tool, care caută permanent tarife mai bune și reemite biletele la un cost mai mic ori de câte ori este posibil.",
        },
      },
      {
        q: {
          en: "How many consultants are assigned to a corporate account?",
          ro: "Câți consultanți sunt alocați unui cont corporate?",
        },
        a: {
          en: "Depending on the company's travel volume, Travel Time assigns a dedicated team of 2 to 9 consultants, together with a dedicated account manager.",
          ro: "În funcție de volumul de călătorii al companiei, Travel Time alocă o echipă dedicată de 2 până la 9 consultanți, alături de un account manager dedicat.",
        },
      },
      {
        q: {
          en: "Is there 24/7 support for business travelers?",
          ro: "Există asistență 24/7 pentru cei care călătoresc?",
        },
        a: {
          en: "Yes. Travel Time provides 24/7 emergency assistance, with contingency plans and duty-of-care tools that locate travelers in real time, so disruptions can be handled proactively. Travel managers can reach the team at any time during an emergency.",
          ro: "Da. Travel Time oferă asistență 24/7 pentru urgențe, cu planuri de contingență și instrumente de duty of care care localizează călătorii în timp real, astfel încât perturbările să fie gestionate proactiv. Travel managerii pot contacta echipa oricând în situații de urgență.",
        },
      },
      {
        q: {
          en: "What does travel program consultancy involve?",
          ro: "În ce constă consultanța pentru programul de travel?",
        },
        a: {
          en: "Travel Time analyzes the company's current technology, processes, supplier relationships and booking behavior, identifies savings and inefficiencies, then helps implement a tailored travel policy and monitors the results. The work is led by a dedicated Key Account Manager.",
          ro: "Travel Time analizează tehnologia, procesele, relațiile cu furnizorii și comportamentul de rezervare al companiei, identifică economiile posibile și ineficiențele, apoi ajută la implementarea unei politici de travel personalizate și urmărește rezultatele. Procesul este coordonat de un Key Account Manager dedicat.",
        },
      },
    ],
  },
  {
    id: "events",
    title: { en: "Corporate events (MICE)", ro: "Evenimente corporate (MICE)" },
    items: [
      {
        q: {
          en: "What kind of corporate events does Travel Time organize?",
          ro: "Ce tipuri de evenimente corporate organizează Travel Time?",
        },
        a: {
          en: "Meetings, conferences, product launches, teambuildings and incentive programs, from 6 to 300 participants. A dedicated Senior Project Manager oversees venue selection, the event road map and budget control. Services include event websites, registration and secure payments, on-site assistance, satisfaction surveys and KPI reporting.",
          ro: "Întâlniri, conferințe, lansări de produse, teambuilding-uri și programe incentive, de la 6 până la 300 de participanți. Un Senior Project Manager dedicat coordonează alegerea locației, planul evenimentului și controlul bugetului. Serviciile includ site-uri de eveniment, înregistrarea participanților și plăți securizate, asistență la fața locului, chestionare de satisfacție și raportarea indicatorilor de performanță.",
        },
        link: { path: "/servicii", label: { en: "Events management", ro: "Organizare evenimente" } },
      },
    ],
  },
  {
    id: "b2b",
    title: { en: "BOOKING TIME for travel agencies", ro: "BOOKING TIME pentru agenții de turism" },
    items: [
      {
        q: { en: "What is BOOKING TIME?", ro: "Ce este BOOKING TIME?" },
        a: {
          en: "BOOKING TIME is Travel Time's B2B platform for travel agencies, with flight tickets and hotel bookings in one place. It gives access to 800,000+ hotels through 9 major accommodation providers (such as Hotelbeds and Expedia), full Amadeus GDS access, direct NDC fares (Lufthansa Group, Aegean, Emirates, Air France, KLM, British Airways and others) and 300+ low-cost carriers through Travelfusion.",
          ro: "BOOKING TIME este platforma B2B a Travel Time pentru agențiile de turism, cu bilete de avion și rezervări de hotel într-un singur loc. Oferă acces la peste 800.000 de hoteluri prin 9 furnizori importanți de cazare (de exemplu Hotelbeds și Expedia), acces complet la Amadeus GDS, tarife NDC directe (Lufthansa Group, Aegean, Emirates, Air France, KLM, British Airways și altele) și peste 300 de companii low-cost prin Travelfusion.",
        },
        link: { path: "/agentii-partenere", label: { en: "Booking Time", ro: "Booking Time" } },
      },
      {
        q: {
          en: "What are the conditions for partner agencies?",
          ro: "Ce condiții au agențiile partenere?",
        },
        a: {
          en: "Partner agencies start with an initial credit of €3,000, which can be increased based on volume. Service fees start from €3 per ticket, with no fees for void or refund where allowed. Access to the IRIX, Amadeus and RTS platforms is free, and partners also get special negotiated airfares, group quotes and 24/7 support, including via WhatsApp.",
          ro: "Agențiile partenere pornesc cu un credit inițial de 3.000 €, care poate crește în funcție de volum. Comisioanele de serviciu încep de la 3 € pe bilet, fără comision pentru void sau refund acolo unde este permis. Accesul la platformele IRIX, Amadeus și RTS este gratuit, iar partenerii beneficiază și de tarife aeriene negociate, oferte pentru grupuri și suport 24/7, inclusiv pe WhatsApp.",
        },
      },
      {
        q: {
          en: "Does BOOKING TIME automatically lower ticket prices?",
          ro: "BOOKING TIME reduce automat prețul biletelor?",
        },
        a: {
          en: "Yes. The automated repricer keeps checking issued tickets: if a better fare becomes available, the price is lowered and the savings are shared with the partner agency.",
          ro: "Da. Repricer-ul automat verifică permanent biletele emise: dacă apare un tarif mai bun, prețul este redus, iar economia este împărțită cu agenția parteneră.",
        },
      },
      {
        q: {
          en: "How can a travel agency become a Travel Time partner?",
          ro: "Cum devine o agenție de turism parteneră Travel Time?",
        },
        a: {
          en: "Request a demo account on the Booking Time page or write to the sales department at parteneri@travel-time.ro.",
          ro: "Solicitați un cont demo de pe pagina Booking Time sau scrieți departamentului de vânzări la parteneri@travel-time.ro.",
        },
        link: { path: "/contact", label: { en: "Request a demo account", ro: "Cerere cont demo" } },
      },
    ],
  },
  {
    id: "holidays-contact",
    title: { en: "Holidays and contact", ro: "Vacanțe și contact" },
    items: [
      {
        q: {
          en: "Does Travel Time also organize holidays?",
          ro: "Travel Time organizează și vacanțe?",
        },
        a: {
          en: "Yes. Holidays are booked on vacante.travel-time.ro, Travel Time's holiday website: package holidays by plane or coach, tours and hotels. The leisure team can also be reached at turism@travel-time.ro.",
          ro: "Da. Vacanțele se rezervă pe vacante.travel-time.ro, site-ul de vacanțe al Travel Time: pachete cu avionul sau cu autocarul, circuite și hoteluri. Echipa de turism poate fi contactată și la turism@travel-time.ro.",
        },
        link: {
          href: "https://vacante.travel-time.ro/?utm_source=travel-time.ro&utm_medium=faq",
          label: { en: "vacante.travel-time.ro", ro: "vacante.travel-time.ro" },
        },
      },
      {
        q: {
          en: "Where is Travel Time located and what are the business hours?",
          ro: "Unde se află Travel Time și care este programul?",
        },
        a: {
          en: "The office is at Strada Popa Tatu nr. 49, Sector 1, Bucharest. Business hours are Monday to Friday, 09:00-18:00. Corporate travelers and partner agencies have 24/7 emergency support.",
          ro: "Biroul se află pe Strada Popa Tatu nr. 49, Sector 1, București. Programul este de luni până vineri, între 09:00 și 18:00. Clienții corporate și agențiile partenere au asistență 24/7 pentru urgențe.",
        },
      },
      {
        q: {
          en: "How can I contact the right department?",
          ro: "Cum contactez departamentul potrivit?",
        },
        a: {
          en: "Call +40 371 12 12 72 or write to: parteneri@travel-time.ro (sales and B2B partners), ticketing@travel-time.ro (airline tickets), turism@travel-time.ro (holidays) or financiar@travel-time.ro (billing). You can also send a message through the contact form.",
          ro: "Sunați la +40 371 12 12 72 sau scrieți la: parteneri@travel-time.ro (vânzări și parteneri B2B), ticketing@travel-time.ro (bilete de avion), turism@travel-time.ro (vacanțe) sau financiar@travel-time.ro (facturare). Puteți trimite și un mesaj prin formularul de contact.",
        },
        link: { path: "/contact", label: { en: "Contact", ro: "Contact" } },
      },
    ],
  },
];

export default FAQ;
